const elementsToShow = 20;

export const calcolaNumeroElementi = (pagina) => ((pagina - 1) * elementsToShow);
